import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import {EuiSpacer} from '@elastic/eui';

interface Props {
  data: any;
}

export const PaisesScreen = (props: Props) => {
  const ref:any = useRef();
  let { data } = props;
  let [selected, setSelected] = useState<any>(undefined);

  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const Actions: Action[] = useMemo(()=> [
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
  ],[selected])

  const getView = useMemo(() => {
    return (
      <>
        <Menu actions={Actions}/>
        <EuiSpacer size="s" />
          <GridResultsScreen
            data={data}
            selector={false}
            menu={false}
            ref={ref}
          />
      </>
    )
  },[data])

  return (
        <>
          {getView}
        </>
  );
};

export default PaisesScreen;
